import { render, staticRenderFns } from "./set_up.vue?vue&type=template&id=6980de04&scoped=true"
import script from "./set_up.vue?vue&type=script&lang=js"
export * from "./set_up.vue?vue&type=script&lang=js"
import style0 from "./set_up.vue?vue&type=style&index=0&id=6980de04&prod&lang=scss&scoped=true"
import style1 from "./set_up.vue?vue&type=style&index=1&id=6980de04&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6980de04",
  null
  
)

export default component.exports